export default "__VITE_ASSET__D6t6bDqL__"